<div class="px-3 py-2 flex items-center">
    <p-checkbox [binary]="true" [disabled]="true" [ngModel]="false" />
</div>

<div class="px-3 py-2">
    <input #itemNumberInput
           class="inline-field inline-field--item"
           type="text"
           [ngModel]="itemNumber()"
           (ngModelChange)="onItemNumberChange($event)"
           (keydown)="onLookupKeydown($event)"
           (focus)="openSuggestions()"
           (blur)="onLookupFieldBlur()"
           [placeholder]="('accounting.financialDocuments.invoiceForm.positionItemNumberPlaceholder' | translate)"
           autocomplete="off" />
</div>

<div class="px-3 py-2 min-w-0">
    <textarea #titleInput
              class="inline-field inline-field--title"
              rows="2"
              [ngModel]="titleQuery()"
              (ngModelChange)="onTitleChange($event)"
              (keydown)="onLookupKeydown($event)"
              (focus)="openSuggestions()"
              (blur)="onLookupFieldBlur()"
              [placeholder]="('accounting.financialDocuments.invoiceForm.positionTitlePlaceholder' | translate)"
              autocomplete="off"></textarea>
</div>

<div class="px-3 py-2">
    <input class="inline-field inline-field--qty text-right"
           type="number"
           min="0"
           step="any"
           [ngModel]="quantity()"
           (ngModelChange)="quantity.set(+$event || 1)"
           (keydown)="onQuantityEnter($event); onFieldArrowKey($event)"
           autocomplete="off" />
</div>

<div class="px-3 py-2">
    <select class="inline-field inline-field--unit"
            [ngModel]="unitId()"
            (ngModelChange)="unitId.set(+$event || null)"
            (keydown)="onFieldArrowKey($event)">
        <option [ngValue]="null">–</option>
        @for (unit of units(); track unit.id) {
            <option [ngValue]="unit.id">{{ unit.translationKey | unitTypesField }}</option>
        }
    </select>
</div>

<div class="px-3 py-2 text-right">
    @if (isPriceEditing()) {
        <input class="inline-field inline-field--price text-right"
               type="number"
               step="0.01"
               min="0"
               [ngModel]="price() ?? selectedProduct()?.price ?? 0"
               (ngModelChange)="price.set($event === '' || $event === null ? null : +$event)"
               (keydown)="onPriceEnter($event); onPriceKeydown($event)"
               (keydown.tab)="onLastFieldTab($event)"
               (blur)="onPriceBlur()"
               autocomplete="off" />
    } @else {
        <button type="button"
                class="inline-field inline-price-trigger"
                (click)="openPriceEdit()"
                (focus)="openPriceEdit()"
                (keydown)="onPriceTriggerKeydown($event)">
            @if (selectedProduct() || price() !== null) {
                {{ fmt(displayUnitPrice()) }} €
            }
        </button>
    }
</div>

<div class="px-3 py-2 text-right text-sm text-p-text whitespace-nowrap">
    @if (grossTotal() > 0) {
        {{ fmt(grossTotal()) }} €
    }
</div>

<div class="u2b-row-actions px-1 py-1 flex items-center justify-end gap-1">
    <u2b-icon-button
        icon="edit"
        [ariaLabel]="('bookingV2.advanced.services.inline.openAdvancedAria' | translate)"
        (clicked)="openAdvanced.emit()" />
</div>

@if (suggestionsOpen() && filteredProducts().length) {
    <div class="booking-v2-service-suggestions-panel">
        <p class="booking-v2-service-suggestions-panel__lead m-0">
            {{ 'bookingV2.advanced.services.inline.suggestionsHint' | translate: { count: filteredProducts().length } }}
        </p>
        <ul class="booking-v2-service-suggestions" role="listbox">
            @for (product of filteredProducts(); track product.id; let i = $index) {
                <li>
                    <button type="button" role="option"
                            class="booking-v2-service-suggestions__option"
                            [class.booking-v2-service-suggestions__option--active]="isSuggestionHighlighted(i)"
                            [attr.data-suggestion-index]="i"
                            [attr.aria-selected]="isSuggestionHighlighted(i)"
                            (mousedown)="onSuggestionMouseDown(product, $event)">
                        <span class="booking-v2-service-suggestions__name">{{ product.name }}</span>
                        @if (product.itemNumber) {
                            <span class="booking-v2-service-suggestions__meta">{{ product.itemNumber }}</span>
                        }
                    </button>
                </li>
            }
        </ul>
    </div>
}
